<template>
  <div id="ssr-page" class="ssr-page" :class="[platformClass]">
    <transition :name="transitionName">
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </transition>
  </div>
</template>
<script>
import Hammer from 'hammerjs';
import globalConfig from './resource/utiles/globalConfig';
export default {
  data() {
    return {
      transitionName: '',
      hammer: null,
      platformClass: ''
    };
  },
  // 构建触发
  beforeCreate() {
    globalConfig.setRouterQuery(this.$route.query);
    globalConfig.setRoute(this.$route);
    globalConfig.init();
  },
  created() {
    let { platformClass } = globalConfig.getPlatformConfig();
    this.platformClass = platformClass;
  },
  watch: {
    // 根据meta层级设置页面切换过渡动画.
    $route(to, from) {
      const toIndex = to.meta.index || 0;
      const fromIndex = from.meta.index || 0;
      const isFromPageUp = from.meta.pageUp && from.meta.pageUp === 1;
      const isToPageUp = to.meta.pageUp && to.meta.pageUp === 1;
      if (!toIndex || !fromIndex) {
        this.transitionName = '';
        return;
      }
      if (isToPageUp) {
        this.transitionName = 'page-up';
      } else if (isFromPageUp) {
        this.transitionName = 'page-down';
      } else {
        this.transitionName =
          toIndex < fromIndex ? 'slide-right' : 'slide-left';
      }
    }
  },
  methods: {
    // 监听页面pan手势，左滑返回上一层.
    handlePanEvent() {
      // 获取页面宽度
      let width = document.body.clientWidth;
      // 半屏宽度
      let halfWidth = width / 2;
      let $contain = document.getElementsByTagName('body')[0];
      let hammer = new Hammer($contain);
      this.hammer = hammer;
      // 根据移动的横向距离及竖项距离，计算夹角
      // 用于兼容hammerjs无法判断方向时
      // 将夹角为45度以内均当为横向滑动
      const getTanDeg = tan => {
        let result = Math.atan(tan) / (Math.PI / 180);
        result = Math.round(result);
        return result;
      };
      hammer.get('pan').set({ direction: Hammer.DIRECTION_RIGHT });
      hammer.on('panend', ev => {
        // 起始x坐标，需要在半屏以内
        let startX = ev.center.x - ev.deltaX;
        // 移动距离，需要小于半屏宽度
        let distance = ev.deltaX;
        let notDown = Math.abs(ev.deltaY) <= 50;
        let isRight =
          notDown &&
          startX <= halfWidth &&
          distance <= halfWidth &&
          ev.direction === Hammer.DIRECTION_RIGHT;
        if (ev.direction !== Hammer.DIRECTION_RIGHT) {
          // tan角度 = 对边 / 邻边
          let angle = getTanDeg(Math.abs(ev.deltaY) / ev.deltaX);
          if (angle <= 45) {
            isRight = notDown && startX <= halfWidth && distance <= halfWidth;
          }
        }
        // 越南实名弹屏，禁止左滑返回
        const isRegistProfile = this.$route.name === 'registProfile';
        if (isRight && !isRegistProfile) {
          this.$router.back();
        }
      });
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.handlePanEvent();
    });
    if (
      globalConfig.getHrefParam('h5') == 1 &&
      globalConfig.getHrefParam('m') == 1
    ) {
      try {
        // 移动端双击禁止：主要是为了禁止放大
        document.addEventListener('dblclick', function (event) {
          event.preventDefault();
        });

        document
          .getElementById('ssr-page')
          .addEventListener('touchmove', function (e) {
            e.stopPropagation();
            e.preventDefault();
          });

        // 移动端快速点击禁止：主要是为了禁止放大
        var lastTouchEnd = 0;
        document.addEventListener(
          'touchend',
          function (event) {
            var now = new Date().getTime();
            if (now - lastTouchEnd <= 300) {
              event.preventDefault();
            }
            lastTouchEnd = now;
          },
          false
        );
      } catch (e) {}
    }
  },
  beforeDestroy() {
    this.hammer.destroy();
  }
};
</script>
<style>
html {
  width: 100%;
  height: 100%;
}
body {
  margin: 0;
  width: 100%;
  height: 100%;
}
.ssr-page {
  width: 100%;
  height: 100%;
  font-size: 0;
}
.ssr-page.is-omni {
  background-color: #f4f4f4;
  /* height: 113%; */
}
@media screen and (orientation: landscape) {
  .ssr-page.is-omni {
    background-color: #f4f4f4;
    /* height: 146%; */
  }
}
</style>
<style lang="scss">
@import './resource/assets/scss/animate.scss';
</style>
